import React from 'react';
import { Card, CardMedia, CardContent, CardActionArea, Typography, IconButton } from '@mui/material';
import { Link } from 'react-router-dom'; // Alteração aqui
import { WhatsappShareButton, FacebookShareButton } from 'react-share';
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa';

const shareButtonStyle = {
  width: 36,
  height: 36,
  border: 0,
  borderRadius: '50%',
  color: '#fff',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
};

const instagramUrl = 'https://www.instagram.com/historiadapeninsula/';

const stripHtml = (value = '') =>
  String(value)
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const CardsItemPodcast = ({ podcast }) => {
  const cleanTitle = stripHtml(podcast?.titulo || '');
  const url = window.location.href;
  const text = cleanTitle;

  return (
    <Card
      sx={{
        maxWidth: 345,
        borderRadius: 3,
        boxShadow: 3,
        textAlign: 'center',
        border: '2px solid transparent',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease',
        '&:hover': {
          transform: 'scale(1.05)',
          boxShadow: 6,
          border: '2px solid #FFD700',
        },
      }}
    >
      <Link to={`/podcast/${podcast._id}`} style={{ textDecoration: 'none' }}>
        <CardActionArea>
          <CardMedia
            component="img"
            height="240"
            image={podcast.linkImagem}
            alt={cleanTitle}
            sx={{
              borderTopLeftRadius: 3,
              borderTopRightRadius: 3,
              transition: 'transform 0.3s ease',
              '&:hover': {
                transform: 'scale(1.05)',
              },
            }}
          />
          <CardContent
            sx={{
              background: 'linear-gradient(to right, #333, rgb(152, 145, 95))',
              padding: '16px',
            }}
          >
                    <Typography 
             variant="h5" 
             component="h2" 
             sx={{ fontWeight: 'bold', color: 'white', fontFamily: 'Lato, sans-serif' }}
           >
              {cleanTitle}
            </Typography>
            
          </CardContent>
        </CardActionArea>
      </Link>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', padding: '10px' }}>
        <WhatsappShareButton
          url={url}
          title={text}
          resetButtonStyle={false}
          aria-label="Compartilhar no WhatsApp"
          style={{ ...shareButtonStyle, backgroundColor: '#25D366' }}
        >
          <FaWhatsapp size={19} />
        </WhatsappShareButton>
        <FacebookShareButton
          url={url}
          quote={text}
          resetButtonStyle={false}
          aria-label="Compartilhar no Facebook"
          style={{ ...shareButtonStyle, backgroundColor: '#1877F2' }}
        >
          <FaFacebookF size={18} />
        </FacebookShareButton>
        <IconButton
          component="a" 
          href={instagramUrl} 
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Abrir Instagram"
          sx={{
            width: 36,
            height: 36,
            color: '#fff',
            background: 'linear-gradient(135deg, #f9ce34 0%, #ee2a7b 48%, #6228d7 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #f9ce34 0%, #ee2a7b 48%, #6228d7 100%)',
              filter: 'brightness(0.95)',
            },
          }}
        >
          <FaInstagram size={19} />
        </IconButton>
      </div>
    </Card>
  );
};

export default CardsItemPodcast;
